import { getCookie } from 'cookies-next';
const baseUrl = process.env.NEXT_PUBLIC_BASE_URL
import { saleTypes } from '@constants/saleTypes';



export const getDistrict = async (slug, filters, localeValue = 'en') => {
    const id = getCookie('id')
    let currencyValue = getCookie('currency')
    // let localeValue = getCookie('NEXT_LOCALE')

    // let { saleType, page } = filters
    let { saleType, bts, project, category, room, page, minprice, maxprice, petfriendly, map, sort } = filters
    // console.log(filters)

    if (saleType == undefined || saleType == null) {
        saleType = saleTypes[0].value
    }

    const url = `${baseUrl}/districts/${slug}?saleType=${saleType}&bts=${bts}&project=${project}&category=${category}&minprice=${minprice}&maxprice=${maxprice}&room=${room}&petfriendly=${petfriendly}&map=${map}&page=${page}&sort=${sort}`

    const headers = {
        'apikey': process.env.NEXT_PUBLIC_RSTBASE_API_KEY,
        'currency': currencyValue || 'thb',
        'locale': localeValue || 'en',
        'id': id
    }

    const response = await fetch(url, {
        headers: headers,
        // cache: 'no-store'
        next: { revalidate: 1800 } // 30m
    })

    // console.log(response)

    const result = await response.json()

    const likes = getCookie('likes')
    if (id == undefined && likes !== undefined && likes.length > 0 && result.properties.length > 0) {
        console.log('has likes')
        result.properties.forEach(property => {
            if (likes.includes(property.id)) {
                property.isLiked = true
            }
        })
    }
    return result
}